<template>
    <div
        class="relative overflow-hidden rounded-image-default before:rounded-image-default aspect-[calc(382/200)]"
        :class="{
            'before:rounded-image-default before:absolute before:inset-0 before:bg-(--surface-secondary) before:animate-pulse': !imageLoaded,
        }"
    >
        <img
            :src="src"
            :alt="alt"
            class="w-full relative object-cover shrink-0 h-full"
            @load="imageLoaded = true"
        >
    </div>
</template>

<script setup>
    const props = defineProps({
        src: String,
        alt: {
            type: String,
            default: '',
        },
    })

    const imageLoaded = ref(false)
</script>
